module.exports = __webpack_public_path__ + "e-learning-app/static/img/total1.56555d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-area/img/ne/total1.png
// module id = m3AZ
// module chunks = 1